<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <div class="flex items-center justify-between mb-4">
        <label class="block text-sm font-medium">{{ $t('gm.list_supplier_orders') }}</label>
        
      </div>
      
      <PageServerTable
        :headers="headers" 
        :items="items" 
        :items-per-page.sync="ipp" 
        :items-per-page-options="ippofilter" 
        :sort-by="sortby" 
        :items-length="count" 
        :reload-fn="reload"
        :mobile-filter-exclusions="['select']"
        show-select
        v-model.selected="selected"
        :item-value="'PurchaseOrdId'"
        :page="page"
        show-current-page
        @click:row="(event, { internalItem, toggleSelect }) => toggleSelect(internalItem)"
        >
        <template #top>
          <div class="sm:hidden flex justify-end px-3 py-2 border-b border-gray-200">
            <button
              class="text-xs px-3 py-1.5 rounded-md border border-blue-400 text-blue-600 hover:bg-blue-50 transition-colors"
              @click="selected.length === items.length ? selected = [] : selected = [...items]"
            >
              {{ selected.length === items.length ? 'Deseleziona tutti' : 'Seleziona tutti' }}
            </button>
          </div>
        </template>
        <template #item.OrderDate="{ item }">
            <span>
              {{ formatDate(item.OrderDate) }}
            </span>
        </template>
        <template #item.Supplier="{ item }">
            <span>
              {{ item.CompanyName ?? item.Supplier }}
            </span>
        </template>
      </PageServerTable>
    </div>
    <div class="pb-24"></div>
  </div>
  <div class="fixed left-0 right-0 bottom-0 flex justify-center items-center pointer-events-none">
    <div class="flex gap-2 pointer-events-auto bg-white w-full px-4 py-3 justify-center">
      <button v-if="selected.length == 0" class="text-white bg-blue-400 cursor-not-allowed font-medium rounded-lg text-sm px-5 py-2.5 text-center">{{ $t('core.load') }}</button>
      <button v-else-if="selected.length > 0 && selected.length <= 10" class="text-white bg-blue-400 hover:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center" @click="loadOrdersData">{{ $t('core.load') }} {{ selected.map(x=>x.InternalOrdNo).join(", ") }}</button>
      <button v-else class="text-white bg-blue-400 hover:bg-blue-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center" @click="loadOrdersData">{{ $t('core.load') }} {{ selected.length }}</button>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';
import PageServerTable from '@/Components/PageServerTable.vue';

export default {
  props: ['items', 'count', 'ippo', 'filtroExcelEnabled', 'tempBolApproval'],
  components: {
    Link,
    BreadCrumbs,
    Pagination,
    PageServerTable
  },
  data() {
    return {
      search: this.filters?.search || "",
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
        { name: this.$t('modules.ricezione-merce'), href: route('modules.gm.ricezione') }
      ],
      selected: [],
      //deletions: [],
      headers: [],
      sortby: [],
      ipp: 10,
      page: 1
    };
  },
  computed: {
    ippofilter() {
      if (this.filtroExcelEnabled && this.headers.find(x => x.filtervalue)) {
        return [{ value: 500, title: 'Tutti' }];
      }
      else return this.ippo;
    }
  },
  methods: {
    reload(sortby = undefined, itemsperpage = undefined, page = undefined, afterdeletion = false) {
      /*if (afterdeletion)
      return;*/

        if (sortby) this.sortby = sortby;
        if (itemsperpage) this.ipp = itemsperpage;
        if (page) this.page = page;

        if (this.filtroExcelEnabled && this.headers.find(x => x.filtervalue)){
          this.ipp = 500;
        }
        else if (this.ipp === 500) {
          this.ipp = 10;
        }

        //sortBy e ipp passano solo il valore aggiornato come $event, non si modifica realmente, quindi ricaricare le prop
        router.post(window.location.href, { headers: this.headers, sortby: this.sortby, itemsperpage: this.ipp, page: this.page}, { only: ['items', 'count']});
    },

    loadOrdersData()
    {
      if (this.tempBolApproval !== 2 && (new Set(this.selected.map(x=>x.Supplier))).size > 1) {
        alert("Selezionare ordini dello stesso fornitore.");
        return;
      }
      router.post(route('modules.gm.riceviDettagli'), { ids: this.selected.map(x=>x.PurchaseOrdId)}, { only: ['items', 'count'], preserveUrl: true});
    }
  },
  mounted()
  {
    //Primo caricamento
    this.headers = this.$attrs.headers;
    this.ipp = this.$attrs.ipp;
    this.page = this.$attrs.page;
    this.sortby = this.$attrs.sortby;
  }
};
</script>

<style scoped>

@media (max-width: 639px) {
  :deep(.v-data-table__tr--mobile) {
    border-bottom: 3px solid #e5e7eb !important;
    border-top: 3px solid #e5e7eb !important;
  }
}
</style>